import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import Select, {components} from "react-select";
import {Button, Form} from "react-bootstrap";
import {normalizujDane} from "../../utils/helpers";
import {Icons} from "../Icons.jsx";
import SelectedOption from "./SelectedOption.jsx";
import {useDictSearch} from "../../../api/app/queries/useDictSearch.jsx";
import {LabelFor} from "./LabelFor.jsx";

//@@ jest trzynane poza renderem bo traci focus po zaznaczeniu opcji -- ref???

const ValueContainer = ({children, innerRef, ...innerProps}) => {

    const length = innerProps?.selectProps?.selectedValue?.length

    const selectedFirst = innerProps?.selectProps?.selectedValue?.[0]

    let content
    if (!innerProps?.selectProps?.selectedValue || length === 0) {
        content = ''
    } else if (length === 1 && innerProps?.options?.find(option => option.value === selectedFirst.value)?.label) {
        content = '[' + (selectedFirst.value) + '] ' + innerProps?.options?.find(option => option.value === selectedFirst.value)?.label || ''
    } else {
        content = 'Wybrano: ' + length

    }


    return (
        <components.ValueContainer {...innerProps}>
            <div>
                {content}
            </div>
            {children}
        </components.ValueContainer>
    );
};

const MultiSelectList = (props) => {

    const selectAllOption = {
        id: 'wszystko',
        nazwa: 'Zaznacz wszystkie'
    }

    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState(props.value);

    const handleAll = (id, e) => {
        e?.stopPropagation()
        e?.preventDefault()


        if (id === 'wszystko') {
            if (options.length !== (selected?.length)) {
                setSelected(options.filter(o => o.id !== 'wszystko'))
                props.onChange(options.filter(o => o.id !== 'wszystko').map(o => ({value: o.id, label: o.nazwa})))
            } else {
                setSelected([])
                props.onChange([])
            }

        }
    }

    const Option = (innerProps) => {

        let content = <div className={'d-flex align-items-center gap-2'}>
            <input
                type="checkbox" checked={innerProps.isSelected}
                onChange={() => handleAll(innerProps?.data?.value)}/>
            <label

                className={'fw-normal'}>{props.addId ? ('[' + innerProps.value + ']') : null} {innerProps.label}</label>
        </div>


        if (innerProps?.data?.value === 'wszystko') {
            content =
                <div onFocus={() => null} onClick={(e) => handleAll(innerProps?.data?.value, e)}
                     style={{width: '100%', padding: '.75rem'}}>
                    <Button
                        size={'sm'}
                    >
                        Zaznacz/odznacz wszystko
                    </Button>
                </div>
        }


        return (
            <components.Option {...innerProps}>
                {content}
            </components.Option>
        );
    };


// noinspection DuplicatedCode
    const ClearIndicator = (innerProps) => {
        return (
            <div>
                <components.ClearIndicator {...innerProps}>
                    <Icons.clear/>
                </components.ClearIndicator>
            </div>
        );
    };
    const DropdownIndicator = (innerProps) => {
        return (
            <div>
                <components.DropdownIndicator {...innerProps}>
                    <Icons.dropdown color={'#444'} size={22}/>
                </components.DropdownIndicator>
            </div>
        );
    };

    const data = useDictSearch(`${props.endpoint}${props.dictName ? ('/' + props.dictName) : ''}`, !props.options)

    const displaySelectedItems = () => {
        const min = props.displaySelectedFirst ? 0 : 1
        const filtered = options?.filter(o => selected?.map(s => s.value).includes(o.id)).sort((a, b) => a.id - b.id)
        if (selected?.length > 0) {                                                         // likwiduje jednoliniowe szare tło przy braku opcji
            return <div className={'my-2 text-start p-3 bg-light'}>
                {filtered?.length > min ? <div className={'fw-bold'}>Wybrane opcje: </div> : null}
                {filtered?.length > min && filtered?.map((f, idx) => <SelectedOption key={idx}
                                                                                     showId={props.addId}
                                                                                     data={{...f}}/>)}
            </div>
        }
    }


    useEffect(() => {
        setSelected(props.value);
        return () => {
            setSelected(null);
        };
    }, [props.value]);

    useEffect(() => {

        if (data?.data?.list && props.excludeEndsWith) {
            return setOptions(data?.data?.list.filter(i => !i.id?.endsWith(props.excludeEndsWith)).sort((a, b) => a.id?.toString()?.localeCompare(b.id)));
        } else if (data?.data?.list) {
            setOptions(data?.data?.list.sort((a, b) => a.id?.toString()?.localeCompare(b.id)));
        }


        if (props.options?.length && props.excludeEndsWith) {

            setOptions(props.options.filter(i => {

                return !i.value?.endsWith(props.excludeEndsWith)

            }))
        } else if (props.options?.length) {
            setOptions(props.options);
        }

        return () => {
            setOptions(null);
        };
        // eslint-disable-next-line
    }, [data, props.options]);


    const customStyleMultiSelect = {

        menu: (provided, _state) => {
            return {
                ...provided,
                borderRadius: 0,
            }
        },
        option: (provided, state) => {

            const baseStyles = {
                ...provided,
                minHeight: '1.8rem',
                lineHeight: .9,
                fontSize: props.size === 'sm' ? '.9rem' : null,
            }

            if (state.value !== 'wszystko') return baseStyles

            return {
                ...provided,
                margin: 0,
                padding: 0,
            }
        },
        menuList: (provided, _state) => {
            return {
                ...provided,
                zIndex: 100,
            }
        },

        control: (provided, state) => {
            return {
                ...provided,
                '&:hover': {
                    borderColor: null,
                    cursor: 'pointer'
                },
                height: props.size === 'sm' ? 31 : 35,
                borderRadius: 'none',
                cursor: props.disabled ? 'not-allowed' : null,
                border: state.isFocused && '1px solid rgb(134, 163, 208) !important',
                boxShadow: state.isFocused && 'rgba(13, 71, 161, 0.25) 0 0 0 4px !important',
                // backgroundColor:props.disabled ? '#e9ecef' : "#ffffff",
                transition: state.isFocused && 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important',
                outline: state.isFocused && 'none !important',
                overflow: 'hidden',
            }
        },
        dropdownIndicator: (provided, _state) => {
            return {
                ...provided,
                padding: '0 6px',
                marginRight: '.2rem',
                transform: 'scale(.8)'
            }
        }
        ,
        indicatorSeparator: (provided, _state) => {
            return {
                ...provided,
                display: 'none',
            }
        }
        ,
        clearIndicator: (provided, _state) => {
            return {
                ...provided,
                margin: 0,
                padding: 0
            }
        }
        ,
        input: (provided, _state) => {
            return {
                minHeight: props.size === 'sm' ? 24 : 33,
                padding: 0,
                margin: 1
            }
        },
        valueContainer: (provided, _state) => {
            return {
                ...provided,
                margin: 0,
                marginLeft: 10,
                padding: 0,
                marginTop: -22,
                fontWeight: 400,
                textAlign: 'start',
            }
        }
    }


    return <>
        <Form.Group
            title={props.title}
            readOnly={props.readOnly}
            className={'d-flex flex-column'}>
            <div className={'align-baseline'}>
                <LabelFor label={props.label} hideLabel={props.hideLabel}/>
            </div>
            <Select
                tabSelectsValue={false}
                inputId={props.id || props.label}
                title={props.title}
                noOptionsMessage={() => "Brak opcji"}
                isSearchable={false}
                placeholder={""}
                isDisabled={props.disabled}
                value={selected}
                aria-label={props.label || props.title || props.placeholder}
                styles={customStyleMultiSelect}
                selectedValue={selected}
                data-testid={props.dataTestId}
                onChange={(selectedOption) => {
                    props.onChange(selectedOption)
                }}
                controlShouldRenderValue={false}
                loadingMessage={() => "Wczytujemy dane"}
                options={props.options || normalizujDane(props.handleAllOptions ? [selectAllOption, ...options || []] : [...options || []])}
                closeMenuOnSelect={false}
                isMulti
                components={{
                    Option, ClearIndicator, DropdownIndicator, ValueContainer,
                }}
                menuPlacement={"bottom"}
                hideSelectedOptions={false}

            />
            {props.bottomActions && props.bottomActions()}

            {displaySelectedItems()}
        </Form.Group>
    </>
};

MultiSelectList.propTypes = {
    isSelected: PropTypes.bool,
    label: PropTypes.string,
    hideLabel: PropTypes.bool,
    queryId: PropTypes.string.isRequired,
    endpoint: PropTypes.string,
    dictName: PropTypes.string,
    options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    handleAllOptions: PropTypes.bool,                                       // wyświetla na liście opcji przycisk "Zaznacz/odznacz wszystko"
    addId: PropTypes.bool,
    excludeEndsWith: PropTypes.string,
    selectedDisplayHeader: PropTypes.string,
    displaySelected: PropTypes.bool,
    displaySelectedFirst: PropTypes.bool,
    title: PropTypes.string,
    id: PropTypes.string,
    disabled: PropTypes.bool,
};

export default MultiSelectList;
